<div class="modal-div">
  <div class="popup-header ">
    <span class="popup-title header-num">{{ configs.title }}</span>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
  </div>

  <div class="modal-body ">
    <app-dynamic-form
      [form]="dynamicForm"
      [formFields]="fields"
      (modelChange)="handleFieldChange($event)"
    ></app-dynamic-form>
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button
      type="submit"
      class="btn btn-accello-secondary d-block"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-accello-primary-light d-block"
      [disabled]="!dynamicForm.valid"
      (click)="create()"
    >
      {{ configs.saveBtnText }}
    </button>
  </div>
</div>
